export default __webpack_public_path__ + "img/cNzETLeB.45fad5cf.svg";